import { Flex, Text, Box } from '@chakra-ui/react';
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from '@morressier/alembic';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onRemove: () => void;
  isLoading: boolean;
}

const BackToUploadDeleteModal = ({
  onRemove,
  isOpen,
  onClose,
  isLoading
}: Props) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    width='450px'
    closeButtonProps={{
      hidden: true
    }}
  >
    <Flex
      flexDirection={'column'}
      gap={4}
      padding={{ base: 4, md: 8 }}
      justifyContent={'center'}
    >
      <Box color="actionSecondaryCautionContent" fontSize="40px">
        <FontAwesomeIcon icon={faTriangleExclamation} />
      </Box>
      <Text textStyle="headingGroup">Replace manuscript?</Text>
      <Text textStyle="textBody">
        Uploading a new manuscript will delete your current submission and bring
        you back to the first step. Any metadata you have entered will be lost.
      </Text>
      <Flex
        justifyContent={{ base: 'stretch', md: 'flex-end' }}
        direction={{ base: 'column-reverse', md: 'row' }}
        gap={2}
        alignItems="center"
      >
        <Button onClick={onClose} variant="secondary" isDisabled={isLoading} width={{ base: 'full', md: 'auto' }}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={onRemove}
          isDisabled={isLoading}
          isLoading={isLoading}
          width={{ base: 'full', md: 'auto' }}
        >
          Replace Manuscript
        </Button>
      </Flex>
    </Flex>
  </Modal>
);

export default BackToUploadDeleteModal;
